import React from 'react';
import withStyles from '@mui/styles/withStyles';
import { Switch, Route } from 'react-router-dom';
import FinancialAssistanceFunds from '../../../containers/financial-assistance-funds/index';
import { styles } from '../nav-styles';

const FinancialAssistanceFundsComponent = ({ classes }) => (
  <div className={classes.reportContent}>
    <Switch>
      <Route component={FinancialAssistanceFunds} />
    </Switch>
  </div>
);

export default withStyles(styles, { withTheme: true })(FinancialAssistanceFundsComponent);
